export class DefaultDeliveryAddressNotSet {
  constructor() {}
}
